import { fetchWithInterceptors } from 'utils/interceptors';
import { ListResult, SearchResult } from '../types/mynewsdesk.types';

// types
import type { ExcutionResult, RequestConfig } from '../types/press-portal.types';

// utils
import { endpoints } from 'config';

const commonParams = {
  order: 'published',
};

export async function* listGenerator({ info, ...params }: RequestConfig) {
  const listRoute = `${endpoints['newsDesk'].path}/list`;
  let offset = info?.offset || 0;

  if (info?.done) {
    return {
      total_count: 0,
      items: [],
    };
  }

  while (true) {
    const allParams = Object.fromEntries(
      Object.entries({
        ...commonParams,
        ...params,
        offset,
      }).map(([key, value]) => [key, String(value)]),
    );

    const query = new URLSearchParams(allParams).toString();
    const responseRaw = await fetchWithInterceptors(`${listRoute}?${query}`);

    if (!responseRaw.ok) {
      throw new Error(`api error: ${responseRaw.status} ${responseRaw.statusText}`);
    }

    const response: ListResult = await responseRaw.json();

    offset += response.items.length;
    if (response.items.length === 0 || response.total_count <= offset) {
      return response;
    }

    yield response;
  }
}

export async function* searchGenerator(params: RequestConfig) {
  const listRoute = `${endpoints['newsDesk'].path}/search`;
  let page = 1;

  while (true) {
    const allParams = Object.fromEntries(
      Object.entries({
        ...commonParams,
        ...params,
        page,
      }).map(([key, value]) => [key, String(value)]),
    );

    const query = new URLSearchParams(allParams).toString();
    const responseRaw = await fetchWithInterceptors(`${listRoute}?${query}`);

    if (!responseRaw.ok) {
      throw new Error(`api error: ${responseRaw.status} ${responseRaw.statusText}`);
    }

    const response: SearchResult = await responseRaw.json();

    page = response.search_result.summary.page + 1;
    if (response.search_result.summary.page_count < page) {
      return response;
    }

    yield response;
  }
}

export function listResultsReducer(
  acc: ExcutionResult,
  meterial: IteratorResult<ListResult, ListResult>,
) {
  return {
    items: [...acc.items, ...(meterial.value ? meterial.value.items : [])],
    done: acc.done && !!meterial.done,
  };
}

export function searchResultsReducer(
  acc: ExcutionResult,
  meterial: IteratorResult<SearchResult, SearchResult>,
) {
  return {
    items: [...acc.items, ...(meterial.value ? meterial.value.search_result.items : [])],
    done: acc.done && !!meterial.done,
  };
}
